// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dceQR","type":"styles_type__2hjV8","choices":"styles_choices__2GlTC"};